module.exports = __webpack_public_path__ + "img/3.03ae6e5c.png";